/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { Layout } from 'antd';
// import { Avatar, Dropdown, Layout, Menu, Space } from 'antd';
import { useAuth0 } from '@auth0/auth0-react';
import { storage } from "../utils/storage";
import { useFetchGuestUserDetails, useDiscordUserLogin, useDiscordOAuthUrl } from "../services/user.service";
import { discordClientId, discordRedirectUri, guestUserId, guestUserName } from "../helpers/config";
import { useNavigate } from 'react-router-dom';
import { isNotNullUndefinedBlank, toTitleCase } from '../helpers/common';
import { DiscordOutlined } from '@ant-design/icons';
// import { getAuth0ProfileImageUrl, isNotNullUndefined, isValidEmail, toTitleCase } from '../helpers/common';
// import Images from '../assets/images';

const Header = () => {
    const { Header } = Layout;
    // const [isMenuOpen, setIsMenuOpen] = useState(false);
    // const [userName, setUserName] = useState<string>("");
    // const profileImageUrl = useRef<string>("");
    // const { user, isAuthenticated, loginWithRedirect, getAccessTokenSilently, getIdTokenClaims, error } = useAuth0();
    const isGuestUser = useRef(false);
    const isAuthenticatedUser = useRef(false);
    const isLoggingIn = useRef(false);
    const isGuestLoggingIn = useRef(false);
    const navigate = useNavigate();
    const [codeProcessed, setCodeProcessed] = useState(false);
    const [refresh, setRefresh] = useState<boolean>(false);

    useEffect(() => {
        window.addEventListener("authStateChanged", fetchGuestUserData);
        return () => {
            window.removeEventListener("authStateChanged", fetchGuestUserData);
        };
    }, []);

    useEffect(() => {
        isAuthenticatedUser.current = JSON.parse(storage.getLocalProperty("isAuthenticated") ?? false);
        isLoggingIn.current = JSON.parse(storage.getLocalProperty("isLoggingIn") ?? false);
        if ((!isAuthenticatedUser.current && !isLoggingIn.current) && (!isGuestLoggingIn.current && !isGuestUser.current)) {
            fetchGuestUserData();
        }
        else if (!isAuthenticatedUser.current && isLoggingIn.current) {
            const params = new URLSearchParams(window.location.search);
            const code = params.get("code");
            if (code && !codeProcessed) {
                setCodeProcessed(true);
                loginDiscordUser(code);
                window.history.replaceState(null, "", window.location.pathname);
            } else {
                navigate("/");
                storage.clearLocalProperty("isLoggingIn");
            }
        }
        setRefresh(!refresh);
    }, [isAuthenticatedUser.current, isGuestUser.current]);//codeProcessed, isAuthenticatedUser.current

    const discordUserLogin = useDiscordUserLogin({
        onSuccess: (response: any) => {
            if (response.statusCode === 200) {
                isLoggingIn.current = JSON.parse(storage.getLocalProperty("isLoggingIn") ?? false);
                const { userAccessToken, imageUrl, userName } = response.data ?? {};
                if ((userAccessToken ?? "") !== "") {
                    storage.setToken(userAccessToken);
                }
                isGuestUser.current = false;
                isAuthenticatedUser.current = true;
                storage.setLocalProperty("userPicture", (imageUrl || ""));
                storage.setLocalProperty("isGuestUser", isGuestUser.current);
                storage.setLocalProperty("isAuthenticated", isAuthenticatedUser.current);
                const currentUserName = (storage.getLocalProperty("userName") !== guestUserName) ? userName : (storage.getLocalProperty("userName") ?? "");
                storage.setLocalProperty("userName", isNotNullUndefinedBlank(userName) ? toTitleCase(userName) : currentUserName);
                navigate("/");
            } else {
                isLoggingIn.current = false;
                storage.clearLocalProperty("isLoggingIn");
                storage.setLocalProperty("isAuthenticated", isAuthenticatedUser.current);
                storage.setLocalProperty("isGuestUser", isGuestUser.current);
            }
            setRefresh(!refresh);
            window.dispatchEvent(new Event("authStateChanged"));
        }, onError: (error) => {
            isLoggingIn.current = false;
            storage.clearLocalProperty("isLoggingIn");
            console.error(error);
        }
    });

    const loginDiscordUser = (code: string) => {
        discordUserLogin.mutate({ code: code });
    }

    const { mutate: getOAuthUrl } = useDiscordOAuthUrl({
        onSuccess: (url) => {
            storage.setLocalProperty("isLoggingIn", true);
            window.location.href = url;
        },
        onError: (error) => {
            console.error("Error generating OAuth URL:", error);
        },
    });

    const handleDiscordLogin = () => {
        window.localStorage.clear();
        getOAuthUrl({
            clientId: discordClientId,
            redirectUri: discordRedirectUri,
        });
    };

    const fetchGuestUserData = () => {
        isGuestUser.current = JSON.parse(storage.getLocalProperty("isGuestUser") ?? false);
        isAuthenticatedUser.current = JSON.parse(storage.getLocalProperty("isAuthenticated") ?? false);
        if (!isAuthenticatedUser.current && !isGuestUser.current) {
            isGuestLoggingIn.current = true;
            getGuestUserDetails.mutate({ userId: guestUserId });
        }
    };

    const getGuestUserDetails = useFetchGuestUserDetails({
        onSuccess: (response: any) => {
            if (response.statusCode === 200) {
                isGuestLoggingIn.current = false;
                const { idToken, imageUrl } = response.data ?? {};
                if ((idToken ?? "") !== "") {
                    storage.setToken(idToken);
                }
                if ((imageUrl ?? "") !== "") {
                    storage.setLocalProperty("userPicture", imageUrl);
                }
                storage.setLocalProperty("isGuestUser", true);
                storage.setLocalProperty("isAuthenticated", false);
                storage.setLocalProperty("userName", guestUserName);
                isGuestUser.current = JSON.parse(storage.getLocalProperty("isGuestUser") ?? false);
                window.dispatchEvent(new Event("authStateChanged"));
            } else {
                isGuestLoggingIn.current = false;
            }
            setRefresh(!refresh);
        },
    });

    //#region auth0-login
    // const authUserCreateMutation = useAuthUserCreate({
    //     onSuccess: (response: IResponse) => {
    //         if (response.statusCode === 200) {
    //             isExecuting.current = false;
    //             const { userAccessToken, imageUrl } = response.data ?? {};
    //             if ((userAccessToken ?? "") !== "") {
    //                 storage.setToken(userAccessToken);
    //             }
    //             if ((imageUrl ?? "") !== "") {
    //                 storage.setLocalProperty("userPicture", imageUrl);
    //             }
    //             isGuestUser.current = false;
    //             storage.setLocalProperty("isGuestUser", false);
    //             storage.setLocalProperty("isAuthenticated", true);

    //             const currentUserName = (storage.getLocalProperty("userName") !== guestUserName)
    //                 ? storage.getLocalProperty("userName")
    //                 : "";
    //             ;
    //             storage.setLocalProperty("userName", !isValidEmail(user?.name)
    //                 ? toTitleCase(user?.name)
    //                 : toTitleCase(user?.nickname) ?? currentUserName);
    //             window.dispatchEvent(new Event("authStateChanged"));
    //         } else {
    //             console.error(response);
    //         }
    //     }, onError: (error) => {
    //         console.error(error);
    //     }
    // });

    // useEffect(() => {
    //     const getToken = async () => {
    //         if (isAuthenticated) {
    //             try {
    //                 const accessToken = await getAccessTokenSilently();
    //                 const claims = await getIdTokenClaims();
    //                 const roles = claims?.user_roles?.join(',');

    //                 if ((roles || "") === "") {
    //                     navigate("/unauthorized");
    //                 } else {
    //                     const param = {
    //                         idToken: claims?.__raw,
    //                         accessToken: accessToken,
    //                     }
    //                     isExecuting.current = true;
    //                     authUserCreateMutation.mutate(param);
    //                 }
    //             } catch (error) {
    //                 console.error('Error getting token:', error);
    //             }
    //         }
    //         if (isNotNullUndefined(error) || isNotNullUndefined(user)) {
    //             const isUnAuthorized = user?.user_roles?.length === 0;
    //             const isBlocked = ((error?.message ?? "") !== "");
    //             storage.setLocalProperty("isUnAuthorized", isUnAuthorized);
    //             storage.setLocalProperty("isBlocked", isBlocked);

    //             if (isUnAuthorized || isBlocked) {
    //                 navigate("/unauthorized");
    //             }
    //         }
    //     };

    //     getToken();
    // }, [isAuthenticated, error]);

    // useEffect(() => {
    //     // const userRoleId = parseInt(localStorage.getItem('userRoleId') || "0");
    //     // const userName = (!isValidEmail(user?.name) ? toTitleCase(user?.name) : toTitleCase(user?.nickname)) ?? localStorage.getItem('userName') ?? "";
    //     // setUserName(userRoleId === 1 ? "Admin" : userName);
    //     // profileImageUrl.current = (isNotNullUndefined(user?.picture)) ? getAuth0ProfileImageUrl(user?.picture) : storage.getLocalProperty("userPicture");
    //     isAuthenticatedUser.current = JSON.parse(storage.getLocalProperty("isAuthenticated") ?? false) || isAuthenticated;
    //     if (!isAuthenticatedUser.current && !isGuestUser.current) {
    //         fetchGuestUserData();
    //     } else {
    //         storage.setLocalProperty("isAuthenticated", isAuthenticatedUser.current);
    //         storage.setLocalProperty("isGuestUser", isGuestUser.current);
    //     }
    // }, [user, isAuthenticatedUser.current]);

    // useEffect(() => {
    //     if (!isAuthenticated) {
    //         storage.setLocalProperty("isGuestUser", true);
    //     }
    // }, [isAuthenticated]);
    //#endregion

    //#region unused-code
    // const toggleMenu = () => {
    //     setIsMenuOpen(!isMenuOpen);
    // };

    // const profileMenu = (
    //     <Menu
    //         items={[
    //             {
    //                 key: '1',
    //                 label: 'Logout',
    //                 icon: <LogoutOutlined />
    //             },
    //         ]}
    //         onClick={({ key }) => {
    //             if (key === '1') {
    //                 logout({ logoutParams: { returnTo: window.location.origin } });
    //                 window.localStorage.clear();
    //             }
    //         }}
    //     />
    // );
    //#endregion unused-code

    if (isGuestUser.current) {
        return (
            <header className="bg-white shadow-box px-4 md:px-5 sticky top-0 z-10 w-full">
                <div className="flex flex-col lg:flex-row justify-between items-center py-3 px-7">
                    <div className="flex flex-col lg:flex-row items-center justify-between w-full text-center lg:text-left">
                        <p className="text-xs md:text-base font-medium">
                            <strong className="font-bold">Stay Updated with Real-Time Data! </strong>
                            The current version of the app displays data from the previous day. To access the latest real-time updates, please sign in to your account.
                        </p>
                        <button
                            // onClick={() => loginWithRedirect({ appState: { returnTo: window.location.pathname } })}
                            onClick={() => handleDiscordLogin()}
                            className="mt-2 lg:mt-0 py-2 px-4 text-xs lg:text-base text-white border border-blue-midnight bg-blue-midnight rounded hover:bg-transparent hover:text-blue-midnight transition flex justify-between items-center">
                            <DiscordOutlined className="text-[20px] mr-2" />Sign In
                        </button>
                    </div>
                </div>
            </header>
        );
    } else {
        return <></>;
    }
}

export default Header;